import { render, staticRenderFns } from "./ModalDocumentosAdicionarVarios.vue?vue&type=template&id=b2e1a9f4"
import script from "./ModalDocumentosAdicionarVarios.vue?vue&type=script&lang=js"
export * from "./ModalDocumentosAdicionarVarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports